import styled from 'styled-components';
import media from 'styled-media-query';
import { Link } from 'react-router-dom';

import colors from 'themes/Main';
import { styledScroll } from 'styles/styledScroll';

const { white, darkBlue, gray01, gray05 } = colors;

export const BackgroundArea = styled.div`
  z-index: 5;
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100vh;
`;

export const SubmenuContainer = styled.div`
  z-index: 30;
  position: fixed;
  top: 0;
  left: ${({ isVisible }) => (isVisible ? '96px' : '-100%')};
  width: 300px;
  min-height: 100%;
  background-color: ${white};
  box-shadow: 0px 1px 10px rgba(219, 219, 219, 0.2),
    0px 4px 5px rgba(219, 219, 219, 0.12), 0px 2px 4px rgba(219, 219, 219, 0.14);
  transition: all 0.3s linear;
`;

export const SubmenuItems = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 32px;
  margin-top: 64px;

  a {
    margin-top: 32px;
  }
`;

export const RedirectTo = styled(Link)`
  color: ${gray01};

  &:hover {
    transition: all 200ms ease-in;
    color: ${darkBlue};

    &::after {
      margin-left: 12px;
    }
  }

  &::after {
    content: '>';
    position: relative;
    top: 2px;
    margin-left: 8px;
    font-size: 20px;
    font-weight: 700;
    transition: all 200ms ease-in-out;
  }
`;

export const OpenHideNav = styled.button`
  z-index: 10;
  cursor: pointer;
  display: none;
  position: absolute;
  padding: 4px;
  background-color: transparent;
  outline: 0;
  border: 0;
  top: 35px;
  left: 16px;

  &:focus {
    outline: 0;
  }

  ${media.lessThan('medium')`
    display: block;
  `}

  &:hover > div {
    transform: rotate(135deg);

    &::before {
      transform: rotate(95deg);
      top: 0px;
    }

    &::after {
      visibility: hidden;
    }
  }

  div {
    position: relative;
    z-index: 5;
    width: 25px;
    height: 4px;
    background-color: ${white};
    transition: all 0.5s ease-in-out;

    &::after {
      content: '';
      position: absolute;
      top: 10px;
      left: 0;
      right: 0;
      width: 25px;
      height: 4px;
      background-color: ${white};
      transition: all 0.3s ease-out;
    }

    &::before {
      content: '';
      z-index: 5;
      position: absolute;
      top: -10px;
      left: 0;
      right: 0;
      bottom: 0;
      width: 25px;
      height: 4px;
      background-color: ${white};
      transition: all 0.5s ease-in-out;
    }
  }
`;

export const NavContainer = styled.div`
  z-index: ${({ isOpen }) => (isOpen ? 50 : 0)};
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 96px;
  height: 100vh;
  margin-left: ${({ isOpen }) => (isOpen ? 0 : '-96px')};
  background-color: ${white};
  border-right: 1px solid ${gray05};
  overflow: auto;
  transition: all 0.2s ease;
  ${styledScroll};
`;

export const NavLogo = styled.img`
  margin-top: 20px;
  align-self: center;
  height: 40px;
  width: 40px;
  flex-grow: 0;
`;

export const NavItemsContainer = styled.div`
  margin-top: 32px;
  flex-grow: 1;
`;

export const NavItems = styled.div``;

export const Logout = styled.button`
  background: none;
  border: 0;
  margin: 20px 0;
  flex-grow: 0;
`;
